import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiRequest } from "../../services/getApiRequest";
import { END_POINTS } from "../../Helper/Constant";

export const fetchGameTypes = createAsyncThunk(
    "gameType/fetchGameTypes",
    async (_, { rejectWithValue }) => {
        try {
            const response = await getApiRequest(END_POINTS.GET_GAME_TYPE);
            if (response.success) {
                return response.allGameTypes;
            } else {
                return rejectWithValue(response.message || "Failed to fetch game types");
            }
        } catch (error) {
            return rejectWithValue(error?.message || "Something went wrong");
        }
    }
);

const gameTypeSlice = createSlice({
    name: "gameType",
    initialState: {
        data: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGameTypes.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchGameTypes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchGameTypes.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export default gameTypeSlice.reducer;
